<form class="modal-body" [formGroup]="form" (ngSubmit)="save()" novalidate>
  <div class="centermodal__form">
    <p class="centermodal__title">{{ 'settings.apiUsageLimitsModal.title' | translate }}</p>
    <p class="centermodal__description">{{ 'settings.apiUsageLimitsModal.subtitle' | translate }}</p>

    <div class="centermodal__group-title">{{ 'settings.apiUsageLimitsModal.alertsTitle' | translate }}</div>
    <p class="centermodal__description">{{ 'settings.apiUsageLimitsModal.alertsDescription' | translate }}</p>

    <div class="form-group">
      <label class="field__holder" [appFormControlWrap]="form.get('alertThreshold')">
        <input
          type="tel"
          class="field"
          formControlName="alertThreshold"
          mask="separator.2"
          [prefix]="appService.currencyCodeFor(currency, true)"
          [thousandSeparator]="appService.getThousandSeparator(currency)"
          [decimalMarker]="appService.getDecimalMarker(currency)"
          [dropSpecialCharacters]="true"
          [allowNegativeNumbers]="false"
          [readonly]="isLoading"
        />
        <span class="field__placeholder">{{ 'settings.apiUsageLimitsModal.alertValue' | translate }}</span>
      </label>
    </div>

    <div class="centermodal__group-title">{{ 'settings.apiUsageLimitsModal.limitTitle' | translate }}</div>
    <p class="centermodal__description">{{ 'settings.apiUsageLimitsModal.limitDescription' | translate }}</p>

    <div class="form-group">
      <label class="field__holder" [appFormControlWrap]="form.get('maxLimit')">
        <input
          type="tel"
          class="field"
          formControlName="maxLimit"
          mask="separator.2"
          [prefix]="appService.currencyCodeFor(currency, true)"
          [thousandSeparator]="appService.getThousandSeparator(currency)"
          [decimalMarker]="appService.getDecimalMarker(currency)"
          [dropSpecialCharacters]="true"
          [allowNegativeNumbers]="false"
          [readonly]="isLoading"
        />
        <span class="field__placeholder">{{ 'settings.apiUsageLimitsModal.limitValue' | translate }}</span>
      </label>
    </div>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" (click)="modal.dismiss()" [disabled]="isLoading">
      {{ 'button.cancel' | translate }}
    </button>
    <button type="submit" class="btn-M btn-filled" [disabled]="isLoading">
      {{ 'button.save' | translate }}
    </button>
  </div>
</form>
